import axios from 'axios';
import _ from 'lodash';
import authService from 'services/authService';
import config from './configHelper';

export default {
  get: httpGet,
  post: httpPost,
  patch: httpPatch,
  put: httpPut,
  delete: httpDelete,
  getErrorMessage
};

function httpGet(url: string, queryParams = {}, options = {}) {
  let axiosData = axios.get(`${getUrl(url, options)}${getQueryString(queryParams)}`, getDefaultRequestOptions(options));

  return processRequest(axiosData, options);
}

function httpPost(url: string, data, options = {}) {
  let request = axios.post(getUrl(url, options), JSON.stringify(data), getDefaultRequestOptions(options));

  return processRequest(request, options);
}

function httpPut(url: string, data, options = {}) {
  let request = axios.put(getUrl(url, options), JSON.stringify(data), getDefaultRequestOptions(options));

  return processRequest(request, options);
}

function httpPatch(url: string, data, options = {}) {
  let request = axios.patch(getUrl(url, options), JSON.stringify(data), getDefaultRequestOptions(options));

  return processRequest(request, options);
}

async function httpDelete(url: string, options = {}) {
  let request = axios.delete(getUrl(url, options), getDefaultRequestOptions(options));

  return processRequest(request, options);
}

async function processRequest(axiosRequest, options) {
  try {
    let response = await axiosRequest;

    // if OK return
    if (response.status === 200) return response.data.data || response.data;

    let status = response.status;

    if (status === 401 || status === 403) {
      if (!_.endsWith(window.location.href, '/login')) {
        window.location.href = '/login';
      }
      return;
    }

    if (status === 400 || status === 500) {
      let responseData = response.data;

      if (responseData && responseData.message) {
        throw new Error(responseData.message);
      }
    }

    throw new Error(`Invalid HTTP response status ${status}`);
  } catch (err) {
    let error = err;

    if (!error.status && error.response) {
      error = error.response;
    }

    if (options.acceptableErrorCodes && options.acceptableErrorCodes.includes(error.status)) {
      throw err;
    }

    // uiHelper.showError(err);
    console.log(err);
    throw err;
  }
}

function getQueryString(params) {
  if (!params || !Object.keys(params).length) return '';

  const esc = encodeURIComponent;

  let query = '?';

  query += Object.keys(params)
    .map(k => esc(k) + '=' + esc(params[k]))
    .join('&');

  return query;
}

function getDefaultRequestOptions(options) {
  let result = {
    headers: {'Content-Type': 'application/json', Authorization: getAuthHeader()}
  };

  if (options?.api_key) {
    result.headers['X-Access-Token'] = authService.getApiToken();
  }

  return result;
}

function getUrl(url, options) {
  let mainUrl = options && options.notVersioned ? config.baseUrl : config.baseUrlVersioned;
  if (!_.startsWith(url, '/')) url = '/' + url;

  return `${mainUrl}${url}`;
}

function getAuthHeader() {
  let jwt = authService.getToken();

  return `Bearer ${jwt}`;
}

// TODO use common approach
function getErrorMessage(error) {
  if (!error.status && error.response) {
    let errorResponse = error.response;

    if (errorResponse.data) return errorResponse.data;

    return '';
  }

  return '';
}
